import { FC } from 'react';
import { Container } from '@mui/material';

const UnderConstructionPage: FC = () => (
  <Container maxWidth="lg" className="page">
    <h5>This page Under Construction</h5>
  </Container>
);

export default UnderConstructionPage;
